class SizeChart extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#SizeChartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setSizeChartTrigger();

    // Set up MutationObserver to watch for changes to #size-chart-trigger
    const observer = new MutationObserver(() => {
      this.setSizeChartTrigger();  // Reinitialize the trigger if it changes
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  setSizeChartTrigger() {
    const sizeChartLink = document.querySelector('#size-chart-trigger');
    sizeChartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(sizeChartLink);
    });
    sizeChartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(sizeChartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('size-chart', SizeChart);